import config from "@/config"
import http from "@/utils/request"

export default {
  approval_cat: {
    add: {
      url: `${config.API_URL}/approval_cat`,
      name: "新增一个流程分类",
      post: async function (data) {
        return await http.post(this.url, { method: 'add.approval_cat.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/approval_cat`,
      name: "编辑一个流程分类",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.approval_cat.item', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/approval_cat`,
      name: "批量编辑流程分类状态",
      post: async function (approval_cat_id, status) {
        return await http.post(this.url, { method: 'set.approval_cat.status', approval_cat_id, status });
      }
    },
    sort: {
      url: `${config.API_URL}/approval_cat`,
      name: "批量编辑流程分类排序",
      post: async function (approval_cat_id, sort) {
        return await http.post(this.url, { method: 'set.approval_cat.sort', approval_cat_id, sort });
      }
    },
    delete: {
      url: `${config.API_URL}/approval_cat`,
      name: "批量删除流程分类",
      post: async function (approval_cat_id) {
        return await http.post(this.url, { method: 'del.approval_cat.list', approval_cat_id });
      }
    },
    item: {
      url: `${config.API_URL}/approval_cat`,
      name: "获取一个流程分类详情",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.approval_cat.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/approval_cat`,
      name: "获取流程分类列表",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.approval_cat.list', ...data });
      }
    }
  },
  approval_mode: {
    add: {
      url: `${config.API_URL}/approval_mode`,
      name: "新增一个流程模型",
      post: async function (data) {
        return await http.post(this.url, { method: 'add.approval_mode.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/approval_mode`,
      name: "编辑一个流程模型",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.approval_mode.item', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/approval_mode`,
      name: "批量编辑流程模型状态",
      post: async function (approval_mode_id, status) {
        return await http.post(this.url, { method: 'set.approval_mode.status', approval_mode_id, status });
      }
    },
    sort: {
      url: `${config.API_URL}/approval_mode`,
      name: "批量编辑流程模型排序",
      post: async function (approval_mode_id, sort) {
        return await http.post(this.url, { method: 'set.approval_mode.sort', approval_mode_id, sort });
      }
    },
    delete: {
      url: `${config.API_URL}/approval_mode`,
      name: "批量删除流程模型",
      post: async function (approval_mode_id) {
        return await http.post(this.url, { method: 'del.approval_mode.list', approval_mode_id });
      }
    },
    item: {
      url: `${config.API_URL}/approval_mode`,
      name: "获取一个流程模型详情",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.approval_mode.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/approval_mode`,
      name: "获取流程模型列表",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.approval_mode.list', ...data });
      }
    }
  },
  approval: {
    add: {
      url: `${config.API_URL}/approval`,
      name: "新增一个流程审批",
      post: async function (data) {
        return await http.post(this.url, { auth: true, method: 'add.approval.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/approval`,
      name: "编辑一个流程审批",
      post: async function (data) {
        return await http.post(this.url, { auth: true, method: 'set.approval.item', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/approval`,
      name: "批量编辑流程审批状态",
      post: async function (approval_id, status) {
        return await http.post(this.url, { auth: true, method: 'set.approval.status', approval_id, status });
      }
    },
    delete: {
      url: `${config.API_URL}/approval`,
      name: "批量删除流程审批",
      post: async function (approval_id) {
        return await http.post(this.url, { auth: true, method: 'del.approval.list', approval_id });
      }
    },
    item: {
      url: `${config.API_URL}/approval`,
      name: "获取一个流程审批详情",
      get: async function (data) {
        return await http.post(this.url, { auth: true, method: 'get.approval.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/approval`,
      name: "获取流程审批列表",
      get: async function (data) {
        return await http.post(this.url, { auth: true, method: 'get.approval.list', ...data });
      }
    }
  },
  approval_filed: {
    add: {
      url: `${config.API_URL}/approval_filed`,
      name: "新增一个流程字段",
      post: async function (data) {
        return await http.post(this.url, { auth: true, method: 'add.approval_filed.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/approval_filed`,
      name: "编辑一个流程字段",
      post: async function (data) {
        return await http.post(this.url, { auth: true, method: 'set.approval_filed.item', ...data });
      }
    },
    delete: {
      url: `${config.API_URL}/approval_filed`,
      name: "批量删除流程字段",
      post: async function (approval_filed_id) {
        return await http.post(this.url, { auth: true, method: 'del.approval_filed.list', approval_filed_id });
      }
    },
    item: {
      url: `${config.API_URL}/approval_filed`,
      name: "获取一个流程字段详情",
      get: async function (data) {
        return await http.post(this.url, { auth: true, method: 'get.approval_filed.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/approval_filed`,
      name: "获取流程字段列表",
      get: async function (data) {
        return await http.post(this.url, { auth: true, method: 'get.approval_filed.list', ...data });
      }
    }
  },
  approval_log: {
    add: {
      url: `${config.API_URL}/approval_log`,
      name: "新增一个申请记录",
      post: async function (data) {
        return await http.post(this.url, { method: 'add.approval_log.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/approval_log`,
      name: "编辑一个申请记录",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.approval_log.item', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/approval_log`,
      name: "批量编辑申请记录状态",
      post: async function (approval_log_id, status) {
        return await http.post(this.url, { method: 'set.approval_log.status', approval_log_id, status });
      }
    },
    delete: {
      url: `${config.API_URL}/approval_log`,
      name: "批量删除申请记录",
      post: async function (approval_log_id) {
        return await http.post(this.url, { method: 'del.approval_log.list', approval_log_id });
      }
    },
    end: {
      url: `${config.API_URL}/approval_log`,
      name: "批量删除申请记录",
      post: async function (approval_log_id) {
        return await http.post(this.url, { method: 'end.approval_log.item', approval_log_id });
      }
    },
    item: {
      url: `${config.API_URL}/approval_log`,
      name: "获取一个申请记录详情",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.approval_log.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/approval_log`,
      name: "获取申请记录列表",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.approval_log.list', ...data });
      }
    }
  },
  approval_records: {
    add: {
      url: `${config.API_URL}/approval_records`,
      name: "新增一个审批记录",
      post: async function (data) {
        return await http.post(this.url, { auth: true, method: 'add.approval_records.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/approval_records`,
      name: "编辑一个审批记录",
      post: async function (data) {
        return await http.post(this.url, { auth: true, method: 'set.approval_records.item', ...data });
      }
    },
    setread: {
      url: `${config.API_URL}/approval_records`,
      name: "编辑一个审批记录",
      post: async function (data) {
        return await http.post(this.url, { auth: true, method: 'set.approval_records.read', ...data });
      }
    },
    select_change: {
      url: `${config.API_URL}/approval_records`,
      name: "编辑一个审批记录",
      post: async function (data) {
        return await http.post(this.url, { auth: true, method: 'set.approval_records.select_change', ...data });
      }
    },
    chaosong: {
      url: `${config.API_URL}/approval_records`,
      name: "编辑一个审批记录",
      post: async function (data) {
        return await http.post(this.url, { auth: true, method: 'set.approval_records.chaosong', ...data });
      }
    },
    status: {
      url: `${config.API_URL}/approval_records`,
      name: "批量编辑审批记录状态",
      post: async function (data) {
        return await http.post(this.url, { auth: true, method: 'set.approval_records.status', ...data });
      }
    },
    delete: {
      url: `${config.API_URL}/approval_records`,
      name: "批量删除审批记录",
      post: async function (approval_records_id) {
        return await http.post(this.url, { auth: true, method: 'del.approval_records.list', approval_records_id });
      }
    },
    item: {
      url: `${config.API_URL}/approval_records`,
      name: "获取一个审批记录详情",
      get: async function (data) {
        return await http.post(this.url, { auth: true, method: 'get.approval_records.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/approval_records`,
      name: "获取审批记录列表",
      get: async function (data) {
        return await http.post(this.url, { auth: true, method: 'get.approval_records.list', ...data });
      }
    }
  }
}
